<!--
    统计管理->组织机构树
-->
<template>
    <div class="grid-content bg-purple">
        <ui-card :title="$t('c.organizations')" class="ibox" icon="nucfont inuc-organization">
            <div class="tree-content statistic-tree">
                <el-tree
                    ref="tree"
                    :data="orgTree"
                    :props="defaultProps"
                    :check-strictly="true"
                    show-checkbox
                    node-key="id"
                    :default-checked-keys="defaultCheckedKeys"
                    :default-expanded-keys="defaultExpandKeys"
                    @check-change="checkChange"
                    :getCheckedNodes="false"
                    :render-after-expand="renderAfterExpand"
                    :render-content="renderContent">
                </el-tree>
            </div>
        </ui-card>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import uiCard from '@/components/Statistics/StatisticUICard.vue';

    export default {
        props: {
            defaultCheckedKeys: {
                type: Array,
                default: () => {
                    return []
                }
            },
            single: {           // 父子节点之间是否严格的不关联
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                orgIds: [],
                name: '',
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                defaultExpandKeys: [],
                renderAfterExpand: true,
            }
        },
        created() {
            this.$store.dispatch('getOrgTree').then(data => {
                data.forEach(v => {
                    if (v.children.length) {
                        this.defaultExpandKeys.push(v.id);
                    }
                });
                this.renderAfterExpand = false;

                this.$nextTick(() => {
                    this.$emit('dataLoaded');
                })
            })
        },
        computed: {
            ...mapGetters([
                'orgTree',
            ])
        },
        methods: {
            renderContent(h, {node, data, store}) {
                return (<span style="flex: 1; display: flex; align-items: center; justify-content: space-between; font-size: 14px; padding-right: 8px;"><span><span>{node.label}</span></span></span>);
            },
            checkChange(val, checked, nodeChecked) {
                let that = this;
                let checkArr = this.$refs.tree.getCheckedKeys();
                this.orgIds = this.deleteSame(checkArr);

                // emit
                this.$emit('orgsChange', this.orgIds);

                if (this.single)  {
                    this.name = this.$refs.tree.getCheckedNodes().map(node => node.name).join(', ')
                    return
                }

                iterator(this.orgTree)
                function iterator(data) {
                    data.forEach(item => {
                        if (item.children) {
                            if (item.id === val.id && checked) {
                                let ids = that.getIds(item)

                                checkArr.push(...ids)
                            } else if (item.id === val.id && !checked) {
                                let ids = that.getIds(item);
                                let checkSet = new Set(checkArr);

                                ids.forEach(id => {
                                    checkSet.delete(id);
                                })
                                checkArr = [...checkSet];
                            } else {
                                iterator(item.children);
                            }
                        }
                    })
                }
                checkArr = Array.from(new Set(checkArr));
                that.$refs.tree.setCheckedKeys(checkArr);
                this.name = this.$refs.tree.getCheckedNodes().map(node => node.name).join(', ');
            },
            deleteSame(array){
                let r = [];
                for (let i = 0, l = array.length; i < l; i++) {
                    for (let j = i + 1; j < l; j++)
                        if (array[i] === array[j]) j = ++i;
                    r.push(array[i]);
                }
                return r;
            },
            getIds (data) {
                function getChildids(arr) {
                    let idsArr = []
                    arr.forEach(item => {
                        if (item.children) {
                            idsArr.push(item.id)
                            idsArr = idsArr.concat(getChildids(item.children))
                        } else {
                            idsArr.push(item.id)
                        }
                    })
                    return idsArr
                }

                function getIds(data) {
                    let ids = [data.id]
                    ids = ids.concat(getChildids(data.children))
                    return ids
                }
                return getIds(data)
            },
        },
        watch: {},
        components: {
            uiCard
        }
    }
</script>

<style scoped lang="scss">
    .ibox{
        .el-tree {
            height: 260px;
            overflow: auto;
        }
        .tree-content {
            padding: 10px 0 0;
        }
    }
</style>

